import { api } from '../axios/AxiosInstances';
import axios from "axios"
const config = {
    headers:{
      "X-API-KEY": "dc30830d-22a9-4574-9e0d-e2868623a3cb"
    }
  }
function getItemByItemid(itemId) {
    var url = (localStorage.getItem("apiType") == "testnet") ? "https://testnet-api.rarible.org/v0.1/" : "https://api.rarible.org/v0.1/"
    console.log(itemId);
    return new Promise((resolve, reject) => {
        axios.get(url + "items/"+itemId.id, config)        
            .then((response)=>{
                if(response ){
                    // console.log("3",response.data)
                    resolve(response.data);
                }
            })
            .catch((error)=>{
                console.log(error);
                reject(error);
            })
    })
}

//signal (optional): an AbortSignal. Aborting it cancels the request.
function getAllCollections(collection, signal) {
    // console.log(collection);
    var url = (localStorage.getItem("apiType") == "testnet") ? "https://testnet-api.rarible.org/v0.1/" : "https://api.rarible.org/v0.1/"
    return new Promise((resolve, reject) => {
        if(collection.continuation){
            url = url + "collections/all?size=25&continuation="+collection.continuation
        }else{
            url = url + "collections/all?size=25"
        }
        axios.get(url, {...config, signal})
        .then((response)=>{
            if(response && response.data && response.data.collections){
                // collections/all already includes meta (name, images), so no per-collection lookups are needed.
                // Collections without NFTs are not filtered out here; opening one shows "Empty Collection".
                response.data["items"] = response.data.collections
                resolve(response.data);
            }
        })
        .catch((error)=>{
            reject(error);
        })      
            // .then((response)=>{
            //     console.log(response);
            //     if(response && response.data && response.data.collections){
            //         console.log(response.data)
            //         resolve(response.data);
            //     }
            // })
            // .catch((error)=>{
            //     reject(error);
            // })
    })
}

function getOwnershipByItemid(itemId) {
    var url = (localStorage.getItem("apiType") == "testnet") ? "https://testnet-api.rarible.org/v0.1/" : "https://api.rarible.org/v0.1/"
    // console.log(itemId);
    return new Promise((resolve, reject) => {
        axios.get(url + "ownerships/byItem?itemId="+itemId.id, config)        
            .then((response)=>{
                if(response ){
                    // console.log("3",response.data)
                    resolve(response.data);
                }
            })
            .catch((error)=>{
                console.log(error);
                reject(error);
            })
    })
}

const COLLECTION_LOOKUP_BATCH_SIZE = 2;
//Some collections make Rarible hang ~30s and then return 500. Give up after this long and skip the card
//(same as any other failed lookup). No retry, so no extra requests.
const COLLECTION_LOOKUP_TIMEOUT_MS = 5000;

function getCollectionById(collectionId, signal) {
    var url = (localStorage.getItem("apiType") == "testnet") ? "https://testnet-api.rarible.org/v0.1/" : "https://api.rarible.org/v0.1/"
    return new Promise((resolve, reject) => {
        axios.get(url + "collections/"+collectionId.id, {...config, signal, timeout: COLLECTION_LOOKUP_TIMEOUT_MS})
            .then((response)=>{
                if(response ){
                    // console.log("3",response.data)
                    resolve(response.data);
                }
            })
            .catch((error)=>{
                if(!axios.isCancel(error)) {
                    console.log(error);
                }
                resolve(error);
            })
    })
}

function getItemsByCollection(collection) {
    // console.log(collection);
    var url = (localStorage.getItem("apiType") == "testnet") ? "https://testnet-api.rarible.org/v0.1/" : "https://api.rarible.org/v0.1/"
    return new Promise((resolve, reject) => {
        if(collection.continuation){
            url = url + "items/byCollection?collection="+collection.id+ "&continuation="+collection.continuation
        }else{
            url = url + "items/byCollection?collection="+collection.id
        }
        axios.get(url, config)        
            .then((response)=>{
                
                if(response && response.data && response.data.items){
                    // console.log(response.data)
                    resolve(response.data);
                }
            })
            .catch((error)=>{
                reject(error);
            })
    })
}

//signal (optional): an AbortSignal. Aborting it cancels the requests in flight and skips the remaining lookups.
function getTrendingCollections(data, signal) {
    var url = (localStorage.getItem("apiType") == "testnet") ? "https://testnet-api.rarible.org/v0.1/" : "https://api.rarible.org/v0.1/"
    return new Promise((resolve, reject) => {
        // console.log(data);
        if(data.continuation){
            url += "data/rankings/collections/volume?blockchain=ETHEREUM&period=D7&sort=VOLUME_USD_DESC&limit=25&continuation="+data.continuation
        }else{
            url += "data/rankings/collections/volume?blockchain=ETHEREUM&period=D7&sort=VOLUME_USD_DESC&limit=25"
        }
        axios.get(url, {...config, signal})
            .then(async(response)=>{
                if(response.data ){
                    // console.log(response.data);
                    // look up collections a few at a time so Rarible doesn't rate limit us (429)
                    var values = [];
                    for (var i = 0; i < response.data.result.length; i += COLLECTION_LOOKUP_BATCH_SIZE) {
                        var batch = response.data.result.slice(i, i + COLLECTION_LOOKUP_BATCH_SIZE);
                        var batchValues = await Promise.all(batch.map((item) => getCollectionById(item, signal)));
                        if(signal && signal.aborted) {//user left the home screen, skip the remaining lookups
                            reject(new axios.CanceledError());
                            return;
                        }
                        values = [...values, ...batchValues];
                    }
                    response.data["items"] = values
                    // console.log("5 trending",response); // [3, 1337, "foo"]
                    resolve(response.data);
                    // console.log("2",response.data)
                    resolve(response);
                }
            })
            .catch((error)=>{
                reject(error);
            })
    })
}



function getCollectionsLeaderboard(data) {
    var url = (localStorage.getItem("apiType") == "testnet") ? "https://testnet-api.rarible.org/v0.1/" : "https://api.rarible.org/v0.1/"
    return new Promise((resolve, reject) => {
        if(data.offset){
            url += "data/leaderboards/collections?offset="+data.offset
        }else{
            url += "data/leaderboards/collections?limit=20"
        }
        axios.get(url, config)        
            .then(async(response)=>{
                if(response.data ){
                    await Promise.all(response.data.map(async (item) => {
                      const contents = await getCollectionById(item)
                      return contents
                    })).then((values) => {
                        console.log("5",values); // [3, 1337, "foo"]
                        resolve(values);
                      });
                    console.log("9",response.data)
                    // resolve(response);
                }
            })
            .catch((error)=>{
                reject(error);
            })
    })
}

function getBuyerLeaderboard(paginationConfig) {
    var url = (localStorage.getItem("apiType") == "testnet") ? "https://testnet-api.rarible.org/v0.1/" : "https://api.rarible.org/v0.1/"
    return new Promise((resolve, reject) => {

        axios.get(url + "data/leaderboards/buyers", config)        
            .then(async(response)=>{
                if(response.data ){
                    await Promise.all(response.data.map(async (item) => {
                      const contents = await getCollectionById(item)
                      return contents
                    })).then((values) => {
                        console.log("5",values); // [3, 1337, "foo"]
                        resolve(values);
                      });;
                    // console.log("2",response.data)
                    // resolve(response);
                }
            })
            .catch((error)=>{
                reject(error);
            })
    })
}

const USER_ITEMS_CACHE_KEY = "userItemsCache";

//The signed-in wallet's items are fetched once and reused (home screen, slideshow) until sign-out.
//The cache is tagged with the address, so a different wallet never sees another wallet's items.
function getUserItems(collectionId) {
    var url = (localStorage.getItem("apiType") == "testnet") ? "https://testnet-api.rarible.org/v0.1/" : "https://api.rarible.org/v0.1/"
    return new Promise((resolve, reject) => {
        const address = localStorage.getItem('metaMaskAccount');
        if(!address || address == 'null'){//signed out
            resolve([]);
            return;
        }
        try {
            const cached = JSON.parse(localStorage.getItem(USER_ITEMS_CACHE_KEY));
            if(cached && cached.address == address && Array.isArray(cached.items)) {
                resolve(cached.items);
                return;
            }
        }
        catch(error) {
            //unreadable cache: fetch again
        }
        axios.get(url + "items/byOwner?owner=ETHEREUM:"+address, config)        
            .then((response)=>{
                if(response ){
                    // console.log("3",response.data)
                    try {
                        localStorage.setItem(USER_ITEMS_CACHE_KEY, JSON.stringify({address: address, items: response.data.items}));
                    }
                    catch(error) {
                        console.log("could not cache user items", error);//e.g. storage full; still show the items
                    }
                    resolve(response.data.items);
                }
            })
            .catch((error)=>{
                console.log(error);
                reject(error);
            })
    })
}

//call on sign-out so the next sign-in fetches fresh items.
function clearUserItemsCache() {
    localStorage.removeItem(USER_ITEMS_CACHE_KEY);
}

function getAllModels(paginationConfig) {
    return new Promise((resolve, reject) => {
            api.post('/managefiles/filedatafilter', paginationConfig)
            .then((response)=>{
                resolve(response.data.result);
            })
            .catch((error)=>{
                reject(error);
            })
    })
}

function getModelsForPagination(paginationConfig,model) {
    return new Promise((resolve, reject) => {
            api.post('/managefiles/filedata', paginationConfig, {params:{model}})
            .then((response)=>{
                resolve(response);
            })
            .catch((error)=>{
                reject(error);
            })
    })
}

function addModel(modelObject) {
    return new Promise((resolve,reject) => {
        api.post('/managefiles',modelObject)
        .then((response)=>{
            resolve(response);
        })
        .catch((error)=>{
            reject(error);
        })
    })
}

function deleteModelFile(idsObject) {
    return new Promise((resolve,reject) => {
        api.put('managefiles/model',idsObject)
        .then((response)=>{
            resolve(response);
        })
        .catch((error)=>{
            reject(error);
        })
    })
}

function uploadFile(file) {
    let formData = new FormData();
    formData.append("file",file,file.name);
    return new Promise((resolve,reject) => {
        api.post('/upload',formData,{headers:{'Content-Type': 'multipart/form-data'}})
        .then((response)=>{
            resolve(response.data.result);
        })
        .catch((error)=>{
            reject(error);
        })
    })
}

function updateFile(id,fileDetails) {
    return new Promise((resolve,reject) => {
        api.put('/managefiles',fileDetails,{params:{id}})
        .then((response)=>{
            resolve(response);
        })
        .catch((error)=>{
            reject(error);
        })
    })
}

export { getAllModels,getModelsForPagination,addModel,deleteModelFile,uploadFile,updateFile,getItemsByCollection, getTrendingCollections, getCollectionById, getBuyerLeaderboard, getCollectionsLeaderboard, getUserItems, getItemByItemid, getOwnershipByItemid, getAllCollections, clearUserItemsCache }